import { useEffect, useRef } from 'react';
import jwtDecode from 'jwt-decode';
import { createLcaRunMonitor } from './lcaRunMonitor';

export function useLcaRun({
  accountId,
  projectId,
  hostname,
  notify,
  refresh,
  onBusy,
  onStatus,
  kind = 'lca',
  purpose = 'calculation',
}) {
  const monitor = useRef(null);
  const callbacks = useRef({ notify, refresh, onBusy, onStatus });
  callbacks.current = { notify, refresh, onBusy, onStatus };
  useEffect(() => {
    const getLatestToken = () => {
      try {
        const auth = JSON.parse(localStorage.getItem('bcome-admin-auth'));
        const token = auth?.accountToken?.accessToken;
        if (token && String(jwtDecode(token).accountId) === String(accountId))
          return token;
      } catch {
        /* Invalid or removed authentication ends this scope. */
      }
      current.dispose();
      throw new Error('Account scope changed');
    };
    callbacks.current.onBusy(false);
    callbacks.current.onStatus?.(null);
    if (!accountId || !projectId) return;
    const current = createLcaRunMonitor({
      accountId,
      projectId,
      hostname,
      kind,
      purpose,
      storage: sessionStorage,
      getLatestToken,
      notify: (...args) => callbacks.current.notify(...args),
      refresh: () => callbacks.current.refresh(),
      onBusy: (busy) => callbacks.current.onBusy(busy),
      onStatus: (status) => callbacks.current.onStatus?.(status),
    });
    monitor.current = current;
    current.resume();
    return () => {
      current.dispose();
      monitor.current = null;
    };
  }, [accountId, projectId, hostname, kind, purpose]);
  return () => monitor.current?.start();
}
